import { IncidentType } from '@/graphql/generated/schemas'

export interface IncidentOptionI {
  id: string
  incidentId: string
  label: string
  createdAt: string
  status?: string
  type?: IncidentType
}

export interface TypeFilterOptionI {
  label: string
  value: IncidentType | null
}

export enum BoxType {
  IN_BOX = 'InBox',
  OUT_BOX = 'OutBox',
}
export type CornerPoint = {
  id: number
  type?: BoxType
  x: number
  y: number
  scaledX?: number
  scaledY?: number
}

export type TailgateBox = {
  corners: CornerPoint[]
  isValid: boolean
}

export type TailgateGridClick = {
  currentTarget: { getBoundingClientRect: () => DOMRect }
  clientX: number
  clientY: number
}

export type PolyPoint = {
  x: number
  y: number
}

export type TailgateGrid = {
  inBox: TailgateBox
  outBox: TailgateBox
}
